import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '@/lib/axios'
import { HYDRATE } from 'next-redux-wrapper'

function isHydrateAction(action) {
  return action.type === HYDRATE
}

export const paymentMethodsApi = createApi({
  reducerPath: 'paymentMethodsApi',
  baseQuery: axiosBaseQuery(),
  extractRehydrationInfo(action, { reducerPath }) {
    if (isHydrateAction(action) && action.payload?.[reducerPath]) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getPaymentMethods: builder.query({
      query: () => ({
        method: 'GET',
        url: `/membership/payment-methods`,
      }),
      transformResponse: (response) => response.data,
    }),
    addPaymentMethod: builder.mutation({
      query: (paymentData) => ({
        method: 'POST',
        url: '/membership/payment-methods',
        data: paymentData,
      }),
      transformResponse: (response) => response.data,
    }),
    removePaymentMethod: builder.mutation({
      query: (paymentMethodId) => ({
        method: 'DELETE',
        url: `/membership/payment-methods/${paymentMethodId}`,
      }),
    }),
    updatePaymentMethod: builder.mutation({
      query: ({ paymentMethodId, paymentData }) => ({
        method: 'PUT',
        url: `/membership/payment-methods/${paymentMethodId}`,
        data: paymentData,
      }),
    }),
    setPaymentMethodAsDefault: builder.mutation({
      query: (paymentMethodId) => ({
        method: 'POST',
        url: `/membership/payment-methods/${paymentMethodId}/default`,
      }),

    }),
  }),

})

export const {
  useGetPaymentMethodsQuery,
  useAddPaymentMethodMutation,
  useRemovePaymentMethodMutation,
  useUpdatePaymentMethodMutation,
  useSetPaymentMethodAsDefaultMutation,
} = paymentMethodsApi
